import { getAuth, signInWithPopup, GoogleAuthProvider, OAuthProvider, signOut } from 'firebase/auth';
import { getVolunteerByEmail, getVolunteerByAuthUid, linkVolunteerAuth } from './firebase';

const auth = getAuth();

const googleProvider = new GoogleAuthProvider();
const microsoftProvider = new OAuthProvider('microsoft.com');
const yahooProvider = new OAuthProvider('yahoo.com');

async function handleOAuthSignIn(provider) {
  const result = await signInWithPopup(auth, provider);
  const user = result.user;
  const email = user.email?.toLowerCase();

  // Check if already linked by UID
  let volunteer = await getVolunteerByAuthUid(user.uid);

  if (!volunteer && email) {
    // Try linking by email match
    volunteer = await getVolunteerByEmail(email);
    if (volunteer) {
      // Link this auth account to the volunteer doc
      const providerName = result.providerId?.split('.')[0] || 'google';
      await linkVolunteerAuth(volunteer.id, {
        authUid: user.uid,
        authProvider: providerName,
        profileLinkedAt: new Date().toISOString(),
      });
      volunteer = { ...volunteer, authUid: user.uid };
    }
  }

  return { user, volunteer };
}

export const signInWithGoogle = () => handleOAuthSignIn(googleProvider);
export const signInWithMicrosoft = () => handleOAuthSignIn(microsoftProvider);
export const signInWithYahoo = () => handleOAuthSignIn(yahooProvider);

export const signOutVolunteer = () => signOut(auth);
